import { render } from "./OptionboardPhoneticVowel.vue?vue&type=template&id=2d7fe69b&scoped=true"
import script from "./OptionboardPhoneticVowel.vue?vue&type=script&lang=js"
export * from "./OptionboardPhoneticVowel.vue?vue&type=script&lang=js"

import "@/css/components/optionboard-phonetic-vowel.css?vue&type=style&index=0&id=2d7fe69b&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d7fe69b"]])

export default __exports__